/**
 * Parse a SKU temperature requirement string into a numeric range.
 *
 * Rules (case-insensitive, whitespace-trimmed):
 *  - null / "" / "ambient"          → null (no constraint)
 *  - "cold" / "refrigerated"        → { min: 2, max: 8 }
 *  - "frozen"                       → { min: -25, max: -15 }
 *  - a number with optional C/c suffix ("4C", "-20c") → { min: v-2, max: v+2 }
 *  - an "a..b" range ("2..8")       → { min: a, max: b }
 *  - unrecognized non-empty strings → null (treated as ambient, never throws)
 */
export function parseTemperatureReq(req) {
    if (req == null)
        return null;
    const raw = req.trim().toLowerCase();
    if (raw === '' || raw === 'ambient')
        return null;
    if (raw === 'cold' || raw === 'refrigerated')
        return { min: 2, max: 8 };
    if (raw === 'frozen')
        return { min: -25, max: -15 };
    // Range form: "a..b"
    const rangeMatch = raw.match(/^(-?\d+(?:\.\d+)?)\.\.(-?\d+(?:\.\d+)?)$/);
    if (rangeMatch) {
        const a = parseFloat(rangeMatch[1]);
        const b = parseFloat(rangeMatch[2]);
        return { min: Math.min(a, b), max: Math.max(a, b) };
    }
    // Numeric with optional C/c suffix
    const numMatch = raw.match(/^(-?\d+(?:\.\d+)?)c?$/);
    if (numMatch) {
        const v = parseFloat(numMatch[1]);
        return { min: v - 2, max: v + 2 };
    }
    // Unrecognized — treat as ambient
    return null;
}
//# sourceMappingURL=temperatureConstraint.js.map